__turbopack_context__.v({
  "featureItem": "Features-module__2tHuIG__featureItem",
  "featureOverlay": "Features-module__2tHuIG__featureOverlay",
  "featureTag": "Features-module__2tHuIG__featureTag",
  "features": "Features-module__2tHuIG__features",
  "featuresContainer": "Features-module__2tHuIG__featuresContainer",
  "featuresHeading": "Features-module__2tHuIG__featuresHeading",
});
